import React from "react"
import Input from "aldoo-ra/Input"
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline"
import Typography from "aldoo-ra/Typography"

const SearchAndCategories = ({
  searchQuery,
  setSearchQuery,
  searchCategory,
  setSearchCategory,
  getStatusMessage,
  clearSearch,
  handleSearchChange,
}) => {
  return (
    <div className="w-full flex flex-col items-center mx-auto lg:mx-0">
      {/* Categories and Search */}
      <div className="w-full flex flex-col items-center">
        {/* Search Input */}
        <div className="relative w-full max-w-[450px] md:max-w-[315px] lg:max-w-[367px] xl:max-w-[438px]">
          <Input
            variant="transfer"
            placeholder="Search for a blog post"
            icon={<MagnifyingGlassIcon className="w-6 h-6 text-primary" />}
            onChange={handleSearchChange}
            value={searchQuery}
            showClearButton={true}
            onClear={clearSearch}
            
            clearButtonClassName="w-8 h-8 flex items-center justify-center bg-neutral_1 text-text_secondary hover:text-text rounded-full -mr-3 md:-mr-2"
          />
        </div>
      </div>

      {/* Search Status */}
      <div className="flex flex-row justify-center items-center gap-[20px] mt-4">
        <Typography variant="body1" className="my-0">
          {getStatusMessage()}
        </Typography>
      </div>
    </div>
  )
}

export default SearchAndCategories
